import { useState } from "preact/hooks";
import { toast } from "react-hot-toast";
import { apiClient } from "../../constants.ts";
import {
  Button,
  Collapsible,
  CopyableValue,
  inputClass,
  labelClass,
  PageSpinner,
} from "./components.tsx";
import { useAuth, useQuery } from "./db.ts";

export const AgentmailConfig = ({ id }: { id: string }) => {
  const [newApiKey, setNewApiKey] = useState("");
  const [address, setAddress] = useState<string | null>(null);
  const [editing, setEditing] = useState(false);
  const token = useAuth().user?.refresh_token;
  const { data, error, isLoading } = useQuery({
    bots: { $: { where: { id } }, secrets: {} },
  });
  if (isLoading) return <PageSpinner />;
  if (error) return <div>Error: {error.message}</div>;
  const { bots } = data;
  const [bot] = bots;
  if (!bot) return <div>No bot found</div>;
  const isConfigured = (bot.secrets ?? []).some(
    (s: { name: string }) => s.name === "AGENTMAIL_API_KEY",
  );
  const showForm = !isConfigured || editing;
  return (
    <Collapsible title="AgentMail">
      <div className="flex flex-col gap-4">
        {showForm
          ? (
            <div className="flex flex-col gap-3">
              <div>
                <label className={labelClass}>API Key</label>
                <input
                  value={newApiKey}
                  onChange={(e) => setNewApiKey(e.currentTarget.value)}
                  className={inputClass}
                  placeholder="am_..."
                />
              </div>
              <div className="flex gap-2">
                <Button
                  onClick={() => {
                    if (!token) return;
                    toast.promise(
                      apiClient({
                        token,
                        endpoint: "set-agentmail",
                        payload: {
                          botId: bot.id,
                          apiKey: newApiKey,
                        },
                      }).then((res) => {
                        if (!res.success) throw new Error(res.error);
                        if (res.address) setAddress(res.address);
                        setNewApiKey("");
                        setEditing(false);
                      }),
                      {
                        loading: "Connecting AgentMail...",
                        success: "AgentMail connected!",
                        error: (err) =>
                          `Failed to connect AgentMail: ${err.message}`,
                      },
                    );
                  }}
                  disabled={!newApiKey}
                  className="w-full md:w-auto"
                >
                  Connect AgentMail
                </Button>
                {editing && (
                  <Button
                    onClick={() => {
                      setEditing(false);
                      setNewApiKey("");
                    }}
                    className="w-full md:w-auto"
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </div>
          )
          : (
            <div className="flex flex-col gap-3">
              {address && (
                <CopyableValue label="Email Address" value={address} />
              )}
              <div className="text-sm text-text-secondary-light dark:text-text-secondary">
                AgentMail is configured.
              </div>
              <Button
                onClick={() => setEditing(true)}
                className="w-full md:w-auto"
              >
                Reconfigure
              </Button>
            </div>
          )}
      </div>
    </Collapsible>
  );
};
